// Departments
export const DEPARTMENTS = {
  FINANCE: 'finance',
  HR: 'hr',
  SALES: 'sales',
  SUPPORT: 'support',
  ENGINEERING: 'engineering',
  OPERATIONS: 'operations',
};

export const DEPARTMENT_LABELS = {
  [DEPARTMENTS.FINANCE]: 'Finance',
  [DEPARTMENTS.HR]: 'Human Resources',
  [DEPARTMENTS.SALES]: 'Sales',
  [DEPARTMENTS.SUPPORT]: 'Support',
  [DEPARTMENTS.ENGINEERING]: 'Engineering',
  [DEPARTMENTS.OPERATIONS]: 'Operations',
};

// Expense categories
export const EXPENSE_CATEGORIES = {
  SALARY: 'salary',
  RENT: 'rent',
  UTILITIES: 'utilities',
  MARKETING: 'marketing',
  SOFTWARE: 'software',
  HARDWARE: 'hardware',
  TRAVEL: 'travel',
  OFFICE_SUPPLIES: 'office_supplies',
  PROFESSIONAL_SERVICES: 'professional_services',
  MISCELLANEOUS: 'miscellaneous',
};

export const EXPENSE_CATEGORY_LABELS = {
  [EXPENSE_CATEGORIES.SALARY]: 'Salary & Wages',
  [EXPENSE_CATEGORIES.RENT]: 'Rent',
  [EXPENSE_CATEGORIES.UTILITIES]: 'Utilities',
  [EXPENSE_CATEGORIES.MARKETING]: 'Marketing',
  [EXPENSE_CATEGORIES.SOFTWARE]: 'Software & Licenses',
  [EXPENSE_CATEGORIES.HARDWARE]: 'Hardware',
  [EXPENSE_CATEGORIES.TRAVEL]: 'Travel',
  [EXPENSE_CATEGORIES.OFFICE_SUPPLIES]: 'Office Supplies',
  [EXPENSE_CATEGORIES.PROFESSIONAL_SERVICES]: 'Professional Services',
  [EXPENSE_CATEGORIES.MISCELLANEOUS]: 'Miscellaneous',
};

// Invoice statuses
export const INVOICE_STATUS = {
  DRAFT: 'draft',
  SENT: 'sent',
  PAID: 'paid',
  OVERDUE: 'overdue',
  CANCELLED: 'cancelled',
  PARTIALLY_PAID: 'partially_paid',
};

export const INVOICE_STATUS_LABELS = {
  [INVOICE_STATUS.DRAFT]: 'Draft',
  [INVOICE_STATUS.SENT]: 'Sent',
  [INVOICE_STATUS.PAID]: 'Paid',
  [INVOICE_STATUS.OVERDUE]: 'Overdue',
  [INVOICE_STATUS.CANCELLED]: 'Cancelled',
  [INVOICE_STATUS.PARTIALLY_PAID]: 'Partially Paid',
};

export const INVOICE_STATUS_COLORS = {
  [INVOICE_STATUS.DRAFT]: 'default',
  [INVOICE_STATUS.SENT]: 'processing',
  [INVOICE_STATUS.PAID]: 'success',
  [INVOICE_STATUS.OVERDUE]: 'error',
  [INVOICE_STATUS.CANCELLED]: 'default',
  [INVOICE_STATUS.PARTIALLY_PAID]: 'warning',
};

// Alert types
export const ALERT_TYPES = {
  BUDGET_EXCEEDED: 'budget_exceeded',
  INVOICE_OVERDUE: 'invoice_overdue',
  BURN_RATE_HIGH: 'burn_rate_high',
  RUNWAY_LOW: 'runway_low',
  INTEGRATION_DOWN: 'integration_down',
  HR_ATTRITION: 'hr_attrition',
  SALES_PIPELINE_DROP: 'sales_pipeline_drop',
  SUPPORT_SLA_BREACH: 'support_sla_breach',
};

export const ALERT_TYPE_LABELS = {
  [ALERT_TYPES.BUDGET_EXCEEDED]: 'Budget Exceeded',
  [ALERT_TYPES.INVOICE_OVERDUE]: 'Invoice Overdue',
  [ALERT_TYPES.BURN_RATE_HIGH]: 'High Burn Rate',
  [ALERT_TYPES.RUNWAY_LOW]: 'Low Runway',
  [ALERT_TYPES.INTEGRATION_DOWN]: 'Integration Down',
  [ALERT_TYPES.HR_ATTRITION]: 'HR Attrition Risk',
  [ALERT_TYPES.SALES_PIPELINE_DROP]: 'Sales Pipeline Drop',
  [ALERT_TYPES.SUPPORT_SLA_BREACH]: 'Support SLA Breach',
};

// Alert severities
export const ALERT_SEVERITY = {
  CRITICAL: 'critical',
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low',
  INFO: 'info',
};

export const ALERT_SEVERITY_LABELS = {
  [ALERT_SEVERITY.CRITICAL]: 'Critical',
  [ALERT_SEVERITY.HIGH]: 'High',
  [ALERT_SEVERITY.MEDIUM]: 'Medium',
  [ALERT_SEVERITY.LOW]: 'Low',
  [ALERT_SEVERITY.INFO]: 'Info',
};

export const ALERT_SEVERITY_COLORS = {
  [ALERT_SEVERITY.CRITICAL]: '#ef4444',
  [ALERT_SEVERITY.HIGH]: '#f97316',
  [ALERT_SEVERITY.MEDIUM]: '#eab308',
  [ALERT_SEVERITY.LOW]: '#3b82f6',
  [ALERT_SEVERITY.INFO]: '#6b7280',
};
